import { render, staticRenderFns } from "./test1-1.vue?vue&type=template&id=9d9f96bc&scoped=true"
import script from "./test1-1.vue?vue&type=script&lang=js"
export * from "./test1-1.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/page.css?vue&type=style&index=0&id=9d9f96bc&prod&scoped=true&lang=css&external"
import style1 from "./test1-1.vue?vue&type=style&index=1&id=9d9f96bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9f96bc",
  null
  
)

export default component.exports